












































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import {
  FormItem,
  Option,
  Select
} from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
// Types
import {
  ParcelFields,
  ParcelInput
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
// contants
import createPackagingOptions from '@/constants/packagingOptions';
// rules
import rules from '@/rules/rules';

@Component({
  components: {
    'el-form-item': FormItem,
    'nullable-number-input': NullableNumberInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class QuoteParcelDetails extends Vue {
  @Prop() private parcel!: ParcelInput;
  @Prop({ required: true }) private index!: number;

  @Prop({ default: false }) private readOnly!: boolean;
  public editableParcel: ParcelInput = { ...this.parcel };
  public packagingOptions: SelectOption<string>[] = createPackagingOptions();
  private rules = rules;

  emitRemoveParcel() {
    this.$emit('removeParcel');
  }

  @Watch('editableParcel', { deep: true })
  emitParcelDetails() {
    this.$emit('editParcel', this.editableParcel);
  }
}
